<script setup lang="ts">
import { computed } from 'vue';
import { RouterLink, useRoute, useRouter } from 'vue-router';
import { session } from '@/lib/session';
import PendingQueue from './PendingQueue.vue';
import InstallPrompt from './InstallPrompt.vue';

const route = useRoute();
const router = useRouter();

const links = computed(() =>
  [
    { to: '/', label: 'Home', show: true },
    { to: '/register/dd', label: 'Dembi Dollo', show: session.can('dd_registrar') },
    { to: '/register/main', label: 'Main / MBS #2', show: session.can('registrar') },
    { to: '/student-ids', label: 'School IDs', show: true },
    { to: '/paid-applicants', label: 'Paid', show: true },
    { to: '/dd-applicants', label: 'DD applicants', show: true },
    { to: '/failures', label: 'Failures', show: true },
  ].filter((l) => l.show),
);

async function signOut() {
  await session.logout();
  await router.push('/login');
}
</script>

<template>
  <div class="min-h-screen bg-slate-100">
    <header class="bg-brand-900 text-white shadow">
      <div class="mx-auto flex max-w-6xl flex-wrap items-center gap-3 px-4 py-3">
        <RouterLink to="/" class="text-lg font-semibold tracking-tight">MBS Registration</RouterLink>
        <nav class="flex flex-1 flex-wrap gap-1 text-sm">
          <RouterLink
            v-for="link in links"
            :key="link.to"
            :to="link.to"
            class="rounded px-2.5 py-1 hover:bg-white/10"
            :class="route.path === link.to ? 'bg-white/15 font-semibold' : ''"
          >
            {{ link.label }}
          </RouterLink>
        </nav>
        <div v-if="session.user.value" class="flex items-center gap-3 text-sm">
          <span class="hidden sm:inline">{{ session.user.value.name }}</span>
          <button class="rounded border border-white/30 px-2 py-1 hover:bg-white/10" @click="signOut">
            Sign out
          </button>
        </div>
      </div>
    </header>

    <PendingQueue />
    <InstallPrompt />

    <main class="mx-auto max-w-6xl px-4 py-6">
      <slot />
    </main>
  </div>
</template>
